import { ApolloError, ServerError } from '@apollo/client';

interface GraphqlErrorData {
  message: string;
}

interface GraphqlError {
  errors: GraphqlErrorData[];
}

export function isGraphqlError(error: unknown): error is ApolloError {
  if (
    typeof error === 'object' &&
    'name' in error &&
    error.name === 'ApolloError'
  ) {
    return true;
  }
  return false;
}

export function getGraphqlErrors(error: ApolloError) {
  const serverError = error?.networkError as ServerError;
  if (serverError) {
    const errorMessage = serverError?.result as GraphqlError;
    if (errorMessage) {
      return errorMessage?.errors?.map(({ message }) => message)?.join();
    }
    return error.message;
  }
  return error.message;
}
